export default "__VITE_PUBLIC_ASSET__c2bdf898__"